import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '-order-1 flex h-fit w-full items-center gap-2 bg-white px-[10px] pt-[10px] md:pb-[10px] lg:hidden lg:pb-0',
    addToCart: 'static flex-1 xl:min-w-94',
    counter: 'static',
    wishlist: 'flex-center flex size-[50px]',
    wishlistIcon: 'size-6 md:size-8'
  }
});
